import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { View } from '@uncinc/react-drupal-core';

import Page from '../../../containers/Page';
import useClasses from '../../../hooks/useClasses';
import useRoutes from '../../../hooks/useRoutes';

import './style.scss';
import { Main } from '../../../components';

const PageForumOverview: React.FC = () => {
  const { buildClass } = useClasses('PageForumOverview');
  const { t } = useTranslation();
  const { forumRegulations } = useRoutes();

  return (
    <Page className={buildClass()} title={t('pages.forum.documentTitle')}>
      <Main className="col-lg-10 py-8 py-lg-12">
        <div className="row">
          <div className="Page__introduction col-12">
            <h1>{t('pages.forum.title')}</h1>
            <p>
              <Trans i18nKey="pages.forum.introduction">
                {/* eslint-disable-next-line max-len */}
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content, react/jsx-no-target-blank */}
                <a href={forumRegulations} target="_blank" />
              </Trans>
            </p>
          </div>
          <div className="Page__content col-12">
            <View id="forum_categories" display="default" />
          </div>
        </div>
      </Main>
    </Page>
  );
};

export default PageForumOverview;
